import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { SettingsWarnings } from '../molecules/SettingsWarnings';
import { Box } from '@material-ui/core';



const useStyles = makeStyles((theme) => ({
    medewerkerName: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },
    appbar: {
      padding: 0,
      margin: '0 !important',
    },
    userSection: {
      display: 'flex',
      alignItems: 'center',
    }
  }));

interface IDecorations {
    medewerkerName: string;
}

export type AllProps = IDecorations;
export const TopAppBar = (props: AllProps) => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const { t: tCommon } = useTranslation('common');

    
    return (
        <AppBar position="static" className={classes.appbar} >
          <Toolbar>
              <Typography variant="h6" className={classes.title}>
                {tCommon('mainTitle')}
              </Typography>
              <Box className={classes.userSection}>
                <SettingsWarnings />
                <Typography variant="subtitle1" className={classes.medewerkerName}>
                  {props.medewerkerName}
                </Typography>
              </Box>
          </Toolbar>
        </AppBar>
    );
}

export default TopAppBar;